import { render, staticRenderFns } from "./ywCollectionReviewList.vue?vue&type=template&id=138ba478&scoped=true"
import script from "./ywCollectionReviewList.vue?vue&type=script&lang=js"
export * from "./ywCollectionReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ba478",
  null
  
)

export default component.exports